var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 4.75098L18.1667 2.25098V18.751L10.1667 23.251L9.16675 4.75098Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5499 4.39981L19.0499 0.149813C18.6518 -0.0499375 18.1815 -0.0499375 17.782 0.149813L9.91667 4.0839L2.04992 0.149813C1.61075 -0.0683542 1.088 -0.0471043 0.6715 0.212146C0.255 0.471396 0 0.926146 0 1.41773V19.8344C0 20.3713 0.303167 20.8615 0.783417 21.1023L9.28342 25.3523C9.6815 25.5521 10.1518 25.5521 10.5513 25.3523L18.4167 21.4182L26.2834 25.3509C26.4832 25.4515 26.6999 25.5011 26.9167 25.5011C27.1759 25.5011 27.4338 25.4302 27.6604 25.29C28.0783 25.0307 28.3333 24.576 28.3333 24.0844V5.66773C28.3333 5.13081 28.0302 4.64065 27.5499 4.39981ZM11.3333 6.54323L17 3.7099V18.9589L11.3333 21.7922V6.54323ZM2.83333 3.7099L8.5 6.54323V21.7922L2.83333 18.9589V3.7099ZM25.5 21.7922L19.8333 18.9589V3.7099L25.5 6.54323V21.7922Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.081a1c7e.svg";
export { ForwardRef as ReactComponent };